import { Radio, Stack, type Theme, Typography } from '@mui/material';

const NewFieldModalCard = ({
    title,
    description,
    selected,
    onClick,
    disabled = false,
    dataTestId,
}: {
    title: string;
    description: string;
    selected: boolean;
    onClick: () => void;
    disabled?: boolean;
    dataTestId: string;
}) => {
    return (
        <Stack
            p={2}
            direction='row'
            justifyContent='space-between'
            alignItems='start'
            sx={[
                {
                    border: '1px solid',
                    borderColor: 'divider',
                    cursor: 'pointer',
                    minHeight: '125px',
                },
                selected && {
                    borderColor: (theme: Theme) => theme.palette.secondary.main,
                },
                disabled && {
                    cursor: 'default',
                    pointerEvents: 'none',
                    opacity: 0.5,
                },
            ]}
            onClick={onClick}
            width='100%'
        >
            <Stack spacing={0.5}>
                <Typography variant='h6' color='primary'>
                    {title}
                </Typography>
                <Typography variant='body2' color='primary.mui.inactive'>
                    {description}
                </Typography>
            </Stack>
            <Radio checked={selected} color='secondary' data-testid={dataTestId} />
        </Stack>
    );
};

export default NewFieldModalCard;
